<template>
  <div class="selects">
    <loading v-if="!selects" />

    <div v-if="selects">
      <select-table
        :selects="selects"
        :has_more="has_more"
        :loading="loading"
      ></select-table>
    </div>
  </div>
</template>

<script>
import adminApi from "@/api/admin";
import SelectTable from "@/components/select/SelectTable.vue";
import { mapGetters } from "vuex";
import utils from "@/utils/userType";
import Loading from "@/components/shared/Loading.vue";

export default {
  components: {
    SelectTable,
    Loading,
  },
  data() {
    return {
      search: "",
      loading: true,
      selects: null,
      has_more: null,
    };
  },
  mounted() {
    // wait for user details to exist before routing
    this.waitThenRoute();
  },
  computed: {
    ...mapGetters(["user_details", "account_details"]),
    is_admin() {
      return utils.is_admin(this.user_details);
    },
  },
  watch: {
    $route() {
      this.refresh_filters();
    },
    user_details() {
      this.refresh_filters();
    },
  },
  methods: {
    refresh_filters() {
      this.loading = true;
      this.selects = [];

      var account_id = this.$route.params.account_id;

      const start_date = this.$route.query.start_date || "";
      const end_date = this.$route.query.end_date || "";
      const sort = this.$route.query.sort || "desc";
      const page_id = this.$route.query.paging_id || "";
      const named_select_only =
        this.$route.query.named_only === "true" || false;
      this.$log.debug(
        `refreshing filters with the following parameters: account_id=${account_id}, start_date=${start_date}, end_date=${end_date}, sort=${sort}, paging_id=${page_id}, named_select_only=${named_select_only}`
      );
      var selected_account = this.$route.query.selected_account;
      if (selected_account) {
        this.$log.debug(`we have a selected_account=${selected_account}`);
        account_id = selected_account;
      }

      let filters = this.$route.query.filters || [];
      // filters list with one item returns a string, cast to array
      this.$route.query.filters =
        typeof filters == "string" ? [filters] : filters;
      filters = this.$route.query.filters;

      // build filters query for many filters
      let api_filters = "";
      for (let i = 0; i < filters.length; i++) {
        api_filters += `&filter=${filters[i]}`;
      }

      // prevent api being called before dates are set
      if (start_date && end_date) {
        this.$log.debug(
          `getting select listing page since we have a start_date=${start_date} and end_date=${end_date}...`
        );
        return adminApi
          .get_select_listing_page(
            account_id,
            page_id,
            start_date,
            end_date,
            sort,
            named_select_only,
            api_filters
          )
          .then((response) => {
            this.selects = response.data.data;
            this.has_more = response.data.has_more;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            this.selects = [];
          });
      }
    },
    is_supported_account(account_id) {
      return utils.is_supported_account(account_id, this.user_details);
    },
    waitThenRoute() {
      if (this.user_details.account_id) {
        if (utils.is_admin_or_support(this.user_details)) {
          this.refresh_filters();
        } else {
          // if just a regular user then route with the user_id as a filter
          this.$router.replace({
            name: "account-selects",
            params: { account_id: this.user_details.account_id },
            query: {
              start_date: this.$route.query.start_date || "",
              end_date: this.$route.query.end_date || "",
              filters: [`user_id:${this.user_details.user_id}`],
            },
          });
        }
      } else {
        setTimeout(this.waitThenRoute, 200);
      }
    },
  },
};
</script>
